import { observable, action, makeObservable } from 'mobx';

export interface IViewportMessagesData {
  groupId: string;
  messageId: string;
}

export class ViewportMessages {
  @observable viewportMessages: IViewportMessagesData[] = [];

  constructor() {
    makeObservable(this);
  }

  @action public addViewportMessage(data: IViewportMessagesData): void {
    if (!this.isMessageInViewport(data)) {
      this.viewportMessages = [...this.viewportMessages, data];
    }
  }

  @action public removeViewportMessage(groupId: string, messageId: string): void {
    this.viewportMessages = this.viewportMessages.filter(
      (item) => !(item.groupId === groupId && item.messageId === messageId)
    );
  }

  private isMessageInViewport({ groupId, messageId }: IViewportMessagesData): boolean {
    return this.viewportMessages.some(
      (item) => item.groupId === groupId && item.messageId === messageId
    );
  }
}
